/* eslint-disable */
import { useState } from "react";
import "../../styles/activityScore.scss";
import LongArrow from "components/common/icons/longArrowIcon";
import MainTooltip from "components/common/mainTooltip/MainTooltip";

const ScoreGauge = ({ scoreValue }) => {
  const scorePercentage = scoreValue; // Assuming the score is out of 10

  return (
    <div className="score_gauge_container">
      <div className="score_gauge_bar">
        <div
          className="score_gauge_fill"
          style={{
            width: `${scorePercentage}%`,
            background: "linear-gradient(to right, red, yellow, green)",
            backgroundSize: `${100 / (scorePercentage / 100)}% 100%`, // Adjust the background size based on the score percentage
            height: "100%",
            borderRadius: "14px",
          }}
        ></div>
      </div>
    </div>
  );
};

const ScoreScale = ({ scoreValue }) => {
  let scoreScaleValue = null;
  if (scoreValue < 4) {
    scoreScaleValue = (
      <div className="score_scale_value">
        <p>Score 0 - 30: Poor</p>
        <MainTooltip tooltipText={"Poor"} />
      </div>
    );
  } else if (scoreValue >= 4 && scoreValue < 7) {
    scoreScaleValue = (
      <div className="score_scale_value">
        <p>Score 40 - 60: Not Bad</p>
        <MainTooltip tooltipText={"Not Bad"} />
      </div>
    );
  } else if (scoreValue >= 7 && scoreValue < 9) {
    scoreScaleValue = (
      <div className="score_scale_value">
        <p>Score 70 - 80: Good</p>
        <MainTooltip tooltipText={"Good"} />
      </div>
    );
  } else if (scoreValue >= 9) {
    scoreScaleValue = (
      <div className="score_scale_value">
        <p>Score 90 - 100: Great</p>
        <MainTooltip tooltipText={"Great"} />
      </div>
    );
  }

  return <div className="score_scale_container">{scoreScaleValue}</div>;
};

const ScoreBreakDown = (props) => {
  const {
    breakdownTitle = "Score Breakdown",
    isBilateral = false,
    breakdownValue = 0,
    breakdownLeft = "-",
    breakdownRight = "-",
  } = props;

  const scorePercentage = breakdownValue;

  return (
    <div className="score_breakdown_row">
      {isBilateral ? (
        <div className="score_breakdown_bilateral">
          <div className="score_limb score_breakdown_left">
            <h3>Left</h3>
            <h4>{breakdownLeft}</h4>
          </div>
          <div
            className="score_breakdown_bilateral_center"
            style={{
              width: `100%`,
              background: "linear-gradient(to right, red, yellow, green)",
              backgroundSize: `1000000% 100%`,
              backgroundPosition: `${scorePercentage}% 0`,
              height: "100%",
              borderRadius: "14px",
            }}
          >
            <div className="score_breakdown_title">{breakdownTitle}</div>
            <p>{breakdownValue}</p>
          </div>
          <div className="score_limb score_breakdown_right">
            <h3>Right</h3>
            <h4>{breakdownRight}</h4>
          </div>
        </div>
      ) : (
        <div
          className="score_breakdown_unilateral"
          style={{
            width: `100%`,
            background: "linear-gradient(to right, red, yellow, green)",
            backgroundSize: `1000% 100%`,
            backgroundPosition: `${scorePercentage}% 0`,
            borderRadius: "14px",
          }}
        >
          <div className="score_breakdown_title">{breakdownTitle}</div>
          <p>{breakdownValue}</p>
        </div>
      )}
    </div>
  );
};

const ActivityScore = (props) => {
  const {
    metricTitle = "Metric Title",
    activityScoreClassName = "chart_container toggle-metric-class",
    activityScoreID,
    metricScoreTitle = "Gait Score",
    metricScoreValue = 7.41,
    breakdownTitle = "Activity Score Breakdown",
    sessionData = [],
    getSucceededData = () => ({}),
    sessionScoreMetrics,
  } = props;

  const [scoreToggled, setScoreToggled] = useState(false);

  const data = getSucceededData(sessionData)?.raw;

  const primaryScoreValue =
    data?.[sessionScoreMetrics?.scorePrimaryKey]?.[
      sessionScoreMetrics.primayScore.primaryKey
    ]?.toFixed(2);

  return (
    <div className={activityScoreClassName} id={sessionScoreMetrics?.scoreID}>
      <div className="metric_name">
        <div className="metric_title">
          <h3>{sessionScoreMetrics?.scoreName}</h3>
        </div>
      </div>
      <div
        className={`metric_score_container ${
          scoreToggled
            ? "metric_score_container_open"
            : "metric_score_container_closed"
        }`}
      >
        <div className="metric_score">
          <span className="metric_score_title">
            {sessionScoreMetrics?.scoreName}
          </span>
          <span className="metric_score_label">{primaryScoreValue}</span>
          <div className="metric_score_bar">
            <ScoreGauge scoreValue={primaryScoreValue} />
          </div>
          <div className="metric_score_scale">
            <ScoreScale scoreValue={primaryScoreValue} />
          </div>
        </div>
        <div className={`metric_score_description`}>
          <div
            className={`meric_score_toggler`}
            onClick={() => setScoreToggled(!scoreToggled)}
          >
            <LongArrow />
          </div>
          <div className={`metric_score_description_content`}>
            <p>{sessionScoreMetrics?.secondaryScoreTitle}</p>
            {sessionScoreMetrics?.secondaryScore.map((item, index) => {
              if (item?.bilateral) {
                return (
                  <ScoreBreakDown
                    key={`${item?.scoreName}` + index}
                    breakdownTitle={item?.scoreName}
                    isBilateral={item?.bilateral}
                    breakdownValue={data?.[
                      sessionScoreMetrics?.scorePrimaryKey
                    ]?.[item?.scorePrimaryKey]?.[item?.mainKey]?.toFixed(2)}
                    breakdownLeft={data?.[
                      sessionScoreMetrics?.scorePrimaryKey
                    ]?.[item?.scorePrimaryKey]?.[item?.leftKey]?.toFixed(2)}
                    breakdownRight={data?.[
                      sessionScoreMetrics?.scorePrimaryKey
                    ]?.[item?.scorePrimaryKey]?.[item?.rightKey]?.toFixed(2)}
                  />
                );
              } else {
                return (
                  <ScoreBreakDown
                    key={`${item?.scoreName}` + index}
                    breakdownTitle={item?.scoreName}
                    isBilateral={item?.bilateral}
                    breakdownValue={data?.[
                      sessionScoreMetrics?.scorePrimaryKey
                    ]?.[item?.scorePrimaryKey]?.[item?.mainKey]?.toFixed(2)}
                  />
                );
              }
            })}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ActivityScore;
